import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogTitle } from "@mui/material";
import {
  ensureFlttForm,
  newcomerFormPdfUrl,
  saveNewcomerFacts,
} from "../funtionsBD/Mainservice";
import {
  AffiliationFields,
  affiliationFromForm,
  flttGapFieldKeys,
} from "./NewcomerDossierPanel";
import "./NewcomerDossierPanel.css";

export function FlttFormDialog({ open, onClose, userId, clubId, onSaved }) {
  const [dossier, setDossier] = useState(null);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!open) return undefined;
    let cancelled = false;
    setDossier(null);
    setError("");
    setBusy(true);
    ensureFlttForm({ user_id: userId, club_id: clubId })
      .then((payload) => {
        if (!cancelled) setDossier(payload.data);
      })
      .catch((err) => {
        if (!cancelled) setError(err?.message || "Could not open the FLTT form");
      })
      .finally(() => {
        if (!cancelled) setBusy(false);
      });
    return () => {
      cancelled = true;
    };
  }, [open, userId, clubId]);

  const missing = dossier?.affiliation_missing || [];
  const ready = Boolean(dossier) && missing.length === 0;
  const pdfUrl = dossier
    ? newcomerFormPdfUrl({
        token: dossier.access_token,
        dossierId: dossier.dossier_id,
      })
    : "";

  const saveAndPrint = (form) => {
    const affiliation = affiliationFromForm(form);
    const popup = window.open("about:blank", "_blank");
    setBusy(true);
    setError("");
    saveNewcomerFacts({
      dossierId: dossier.dossier_id,
      token: dossier.access_token,
      facts: { affiliation },
    })
      .then((payload) => {
        setDossier({
          ...payload.data,
          access_token: payload.data?.access_token || dossier.access_token,
        });
        if (payload.data?.affiliation_missing?.length) {
          if (popup) popup.close();
          return;
        }
        if (popup) popup.location.href = pdfUrl;
        if (onSaved) onSaved();
      })
      .catch((err) => {
        if (popup) popup.close();
        setError(err?.message || "Could not save the form");
      })
      .finally(() => setBusy(false));
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>FLTT affiliation form</DialogTitle>
      <DialogContent>
        {error ? <p className="nd-error">{error}</p> : null}
        {!dossier && !error ? <p>Loading the form…</p> : null}
        {dossier && ready ? (
          <div className="nd-print">
            <p className="nd-note">
              {dossier.person?.first_name} {dossier.person?.last_name} is already on the form. Print it and sign it by hand.
            </p>
            <div className="nd-actions">
              <button type="button" disabled={busy} onClick={() => window.open(pdfUrl, "_blank", "noopener")}>
                Print and sign
              </button>
            </div>
          </div>
        ) : null}
        {dossier && !ready ? (
          <form
            className="nd-form"
            key={missing.map((item) => item.key).join("-")}
            onSubmit={(event) => {
              event.preventDefault();
              saveAndPrint(event.currentTarget);
            }}
          >
            <p className="nd-note">
              These details were not on the profile. Once they are saved, the form is ready to print and sign.
            </p>
            <AffiliationFields
              affiliation={dossier.affiliation || {}}
              keys={flttGapFieldKeys(missing)}
              required
            />
            <div className="nd-actions">
              <button type="submit" disabled={busy}>Save and print</button>
            </div>
          </form>
        ) : null}
      </DialogContent>
    </Dialog>
  );
}
